import { render, staticRenderFns } from "./ModalAddItemToGroup.vue?vue&type=template&id=08beb78d"
import script from "./ModalAddItemToGroup.vue?vue&type=script&lang=js"
export * from "./ModalAddItemToGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports